import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { Login, Join } from "./screens/Auth";
import { Onboarding } from "./screens/Onboarding";
import { Home } from "./screens/Home";
import { CheckIn } from "./screens/CheckIn";
import { Candidates } from "./screens/Candidates";
import { DropFlow } from "./screens/DropFlow";
import { Reveal } from "./screens/Reveal";
import { Leaderboard } from "./screens/Leaderboard";
import { Commissioner } from "./screens/Commissioner";
import { Diagnostics } from "./screens/Diagnostics";
import { NewLeague } from "./screens/NewLeague";
import { Finale } from "./screens/Finale";

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="app"><div className="loading">Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* Invite links are public until the visitor authenticates to accept. */}
      <Route path="/join/:token" element={<Join />} />

      {/* Device-level notification check. Deliberately outside the league routes
          so it still works when someone is stuck and cannot load a league page. */}
      <Route path="/diagnostics" element={<Diagnostics />} />

      {/* Anyone can start a league, at any time, not only someone with none. */}
      <Route path="/new-league" element={<RequireAuth><NewLeague /></RequireAuth>} />

      <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
      <Route path="/league/:leagueId" element={<RequireAuth><Home /></RequireAuth>} />
      <Route path="/league/:leagueId/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/league/:leagueId/checkin" element={<RequireAuth><CheckIn /></RequireAuth>} />
      <Route path="/league/:leagueId/candidates" element={<RequireAuth><Candidates /></RequireAuth>} />
      <Route path="/league/:leagueId/drop/:dropId" element={<RequireAuth><DropFlow /></RequireAuth>} />
      <Route path="/league/:leagueId/drop/:dropId/reveal" element={<RequireAuth><Reveal /></RequireAuth>} />
      <Route path="/league/:leagueId/leaderboard" element={<RequireAuth><Leaderboard /></RequireAuth>} />
      <Route path="/league/:leagueId/finale" element={<RequireAuth><Finale /></RequireAuth>} />
      <Route path="/league/:leagueId/commissioner" element={<RequireAuth><Commissioner /></RequireAuth>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
